import BaseControl from './../BaseControl';
import FSForms from './../../Form/js/fsForms';
import Immutable from 'Immutable';

/**
 * @author Pavel Homolka
 */
export default class BulkEditDocumentsControl extends BaseControl
{
  /** @type String */
  simpleEditFormId;

  /** @type String */
  advancedEditFormId;

  /** @type String */
  changeURL;

  /** @type String */
  jsClass;

  /** @type Immutable::Map*/
  stateList;

  /** @type bool */
  isAjax = false;

  /** @type jQuery */
  simpleEditForm;

  /** @type jQuery */
  advancedEditForm;

  /** @type Object */
  reducer;

  /** @type int 0 - simple form; 1 - advanced form */
  activeForm;
  
  /** @type String */
  focused;

  /** Construct and init **********************************************************************************************/

  constructor(simpleEditFormId, advancedEditFormId, changeURL, jsClass, stateList)
  {
    super();
    this.simpleEditFormId = simpleEditFormId;
    this.changeURL = changeURL;
    this.jsClass = jsClass;
    this.stateList = stateList;
    if(advancedEditFormId == undefined)
    {
      this.advancedEditFormId = null;
    }
    else
    {
      this.advancedEditFormId = advancedEditFormId;
    }
  }

  /**
   * @return void
   */
  init()
  {
    $.nette.load();
    FSForms.init();
    readOnlySelectSearch();
    readOnlyDateTime();

    this.simpleEditForm = $(`#${this.simpleEditFormId}`);
    this.advancedEditForm = $(`#${this.advancedEditFormId}`);

    // handlers for simple edit form
    this.simpleEditForm.change(function(event)
    {
      this.activeForm = 0;
      this.onChange(event);
    }.bind(this));
    this.simpleEditForm.submit(function(event)
    {
      this.activeForm = 0;
      this.onSubmit(event);
    }.bind(this));
    

    // handlers for advanced edit form
    this.advancedEditForm.change(function(event)
    {
      this.activeForm = 1;
      this.onChange(event);
    }.bind(this));
    this.advancedEditForm.submit(function(event)
    {
      this.activeForm = 1;
      this.onSubmit(event);
    }.bind(this));
    
    $(document).on("blur", ".fs-dateTime-picker",this.onChange.bind(this));
    $(document).on("blur", ".fs-date-picker",this.onChange.bind(this));
    $(document).on("blur", ".fs-time-picker",this.onChange.bind(this));


    // create JS reducer
    if(window[this.jsClass] != undefined)
    {
      this.reducer = Object.assign({}, window[this.jsClass]);

      // call Reducer::init
      if(typeof this.reducer.init === 'function')
      {
        this.reducer.init(this, this.stateList);
      }
    }
  }

  /** Handles *********************************************************************************************************/

  /**
   * @param jQuery.Event event
   */
  onChange(event)
  {
    var currentStateForEl = this.getCurrentStateForEl($(event.target));
    
    // update state
    var newState = Immutable.Map({
      nameMeta: currentStateForEl.name,
      value: currentStateForEl.value,
      isRequired: currentStateForEl.isRequired,
      isReadOnly: this.stateList.getIn([currentStateForEl.name, 'isReadOnly']),
      metadataDefinitionEntity: this.stateList.getIn([currentStateForEl.name, 'metadataDefinitionEntity'])
    });
    var newStateList = this.stateList.set(currentStateForEl.name, newState);
    this.stateList = newStateList.set('changedItem', currentStateForEl.name);

    // call user reducer and refresh form
    if(this.reducer !== undefined && typeof this.reducer.onChange === 'function')
    {
      var newStateList = this.reducer.onChange(this.stateList);

      if(!this.stateList.equals(newStateList))
      {
        this.stateList = newStateList;
        this.refresh();
      }
    }

    // call server side callback
    if(this.canCallServer())
    {
      this.sendState();
    }
  }
  
  canSubmitFormTest()
  {
    return true;
  }

  /**
   * @param jQuery.Event event
   */
  onSubmit(event)
  {
    event.preventDefault();
      
    if( this.canSubmitFormTest() == true)
    {
      if(this.activeForm == 0)
      {
        var form = this.simpleEditForm;
        var form_id = this.simpleEditFormId;
        if(!Nette.validateForm(document.getElementById(this.simpleEditFormId)))
        {
          return false;
        }

      }
      else
      {
        var form = this.advancedEditForm;
        var form_id = this.advancedEditFormId;
        if(!Nette.validateForm(document.getElementById(this.advancedEditFormId)))
        {
          return false;
        }
      }
      
      var formData = new FormData(document.getElementById(form_id));
      var is_safari = isSafari();
      if(is_safari == true)
      {  
        disableEmptyFileInputs(form,formData);
      } 

      $.ajax({
        type: 'POST',
        url: form.attr('action'),
        data: formData,  //form.serialize(),
        processData: false,  // tell jQuery not to process the data, protože jsem nahradil form.serialize
        contentType: false,  // tell jQuery not to set contentType, protože jsem nahradil form.serialize
        beforeSend: this.onBeforeSend.bind(this),
        success: this.onSuccess.bind(this),
        error: this.onError.bind(this),
        complete: this.onComplete.bind(this)
      });

      event.preventDefault();
    }
      
  }

  /** Send state ******************************************************************************************************/

  /**
   * @return void
   */
  sendState()
  {
    if(!this.isAjax)
    {
      $.ajax({
        method: 'POST',
        url: this.changeURL,
        contentType: 'application/json',
        data: JSON.stringify({stateList: this.stateList.toJS()}),
        beforeSend: this.onBeforeSend.bind(this),
        success: this.onSuccess.bind(this),
        error: this.onError.bind(this),
        complete: this.onComplete.bind(this)
      });
    }
  }

  /**
   * @param jqXHR
   * @param setting
   */
  onBeforeSend()
  {
    this.isAjax = true;
    this.showSpin();
  }

  /**
   * @param payload
   * @param textStatus
   * @param jqXHR
   */
  onSuccess(payload)
  {
    this.hideSpin();
    waiter_close();

    if(document.activeElement !== null)
    {  
      this.focused = document.activeElement.id;
    }
    else
    {  
      this.focused = '';
    }
    
    if(payload.snippets)
    {
      for (var id in payload.snippets)
      {
        $(`#${id}`).html(payload.snippets[id]);
      }
      setTimeout(function(){ FSForms.init();}, 10);
    }

    if (payload.redirect)
    {
      window.location.href = payload.redirect;
      return false;
    }

    switch (payload.stateList)
    {
      case 'NO_CHANGES':
        break;
      case 'ERROR':
        this.showMessage(payload.msg, 'danger');
        break;
      case 'MESSAGE':
        this.showMessage(payload.msg, 'info');
        break;
      default:
        this.stateList = Immutable.fromJS(payload.stateList);
    }

    //this.hideSpin();
  }

  /**
   * @param jqXHR
   * @param textStatus
   * @param error
   */
  onError()
  {
    this.hideSpin();
    this.showMessage('HTTP error', 'danger');
  }

  /**
   * @return void
   */
  onComplete()
  {
    if(this.activeForm == 0)
    {
      if(this.focused == '')
      {  
        $(`#${this.getIdByNameForSimpleForm(this.stateList.get('changedItem'))}`).focus();
      }
      else
      {
        $('#'+this.focused).focus();
        $('#'+this.focused).trigger('chosen:activate');
      }
    }
    else
    {
      $(`#${this.getIdByNameForAdvancedForm(this.stateList.get('changedItem'))}`).focus();
    }

    this.isAjax = false;
    
    readOnlySelectSearch();
    readOnlyDateTime();
  }

  /** Helpers *********************************************************************************************************/
  /**
   * Update the form to the current status.
   * @return void
   */
  refresh()
  {
    if(this.activeForm == 0)
    {
      var form = this.simpleEditForm;
    }
    else
    {
      var form = this.advancedEditForm;
    }

    form.find(':input').each((index) =>
    {
      var input = $(form[0][index]);
      var label = $(`label[for='${$(input).attr('id')}']`);
      var name = input.attr('name');

      if(this.stateList.has(name))
      {
        var isRequired = this.stateList.getIn([name, 'isRequired']);
        var isReadOnly = this.stateList.getIn([name, 'isReadOnly']);
        var value = this.stateList.getIn([name, 'value']);
        
        if(isReadOnly == true)
        {  
          input.addClass('not-active', true);
        }
        else
        {
          input.removeClass('not-active', true);
        }  

        input.attr('readonly', isReadOnly);
        input.prop('readonly', isReadOnly);

        input.val(value);
        if(isRequired)
        {
          label.addClass('isRequired');
        }
        else
        {
          label.removeClass('isRequired');
        }
      }
    });
    readOnlySelectSearch();
    readOnlyDateTime();
  }

  /**
   * @param String msg
   * @param String type
   */
  showMessage(msg, type)
  {
    if(this.activeForm == 0)
    {
      var formId = this.simpleEditFormId;
    }
    else
    {
      var formId = 'advancedEditFormModalBody';
    }

    var alert = `<div class="alert alert-${type} alert-dismissible" role="alert"><button type="button" class="close" data-dismiss="alert"><span>&times;</span></button>${msg}</div>`;
    if($(`#${formId} .alert`).length > 0)
    {
      $(`#${formId} .alert`).remove();
    }
    $(`#${formId}`).prepend(alert);
  }

  /**
   * @returns {boolean}
   */
  canCallServer()
  {
    if(this.reducer !== undefined && typeof this.reducer.canCallPHP === 'function')
    {
      return this.reducer.canCallPHP(this.stateList);
    }

    var change_input_array = ['ID_STAT_DOCU', 'ID_CLAS_DOCU', 'ID_RANK_DOCU','FILE_MARK_DOCU','ID_CERT_DOCU','ID_SKART_REZIM_DOCU','DM_CONTRACT_DOCU','ID_LTD_CONF_DOCU'];

    $('.bulk-document-zav').each(function( index )
    {
      change_input_array.push($(this).val());
    });

    if(change_input_array.indexOf(this.stateList.get('changedItem')) != -1)
    {
      return true;
    }

    return false;
  }

  /**
   * @param String name
   * @return String
   */
  getIdByNameForSimpleForm(name)
  {
    return this.simpleEditForm.find(`:input[name="${name}"]`).attr('id');
  }

  /**
   * @param String name
   * @return String
   */
  getIdByNameForAdvancedForm(name)
  {
    return this.advancedEditForm.find(`:input[name="${name}"]`).attr('id');
  }

  /**
   * @return void
   */
  showSpin()
  {
    if(this.activeForm == 0)
    {
      var formId = this.simpleEditFormId;
    }
    else
    {
      var formId = 'advancedEditFormModalBody';
    }

    //$(`#${formId}`).parent().spin();
    
    var formId_parent = $(`#${formId}`).parent();
    var formId_parent_id = formId_parent.attr('id');
    waiter_open('medium','#'+formId_parent_id);
    $(`#${formId}`).css('opacity', '0.5');
  }

  /**
   * @return void
   */
  hideSpin()
  {
    
    if(this.activeForm == 0)
    {
      var formId = this.simpleEditFormId;
    }
    else
    {
      var formId = 'advancedEditFormModalBody';
    }

    //$(`#${formId}`).parent().spin(false);
    waiter_close();
    $(`#${formId}`).css('opacity', '1');

  }
};




// WEBPACK FOOTER //
// ./client-side/MetadataLogic/BulkEditDocuments/BulkEditDocumentsControl.js